import { render, staticRenderFns } from "./CustomDropdownButton.vue?vue&type=template&id=818034e8&"
import script from "./CustomDropdownButton.vue?vue&type=script&lang=js&"
export * from "./CustomDropdownButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports